import React from "react";
import { CheckIcon, PhoneIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { applicationSteps, careerBenefits, careerCommitments, careersImage, teamFlags } from "../data/careers";
import { ui } from "../data/ui";
import { Reveal } from "./Reveal";
export function Careers() {
  const {
    t
  } = useLanguage();
  return <section id="careers" aria-labelledby="careers-title" className="border-t border-gold/30 bg-charcoal py-20 lg:py-28" data-id="element-13" data-mp="1n016acx3zhy2">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-14" data-mp="1rtc27j0dueb7">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-15" data-mp="1d3emzskfkyy5">
          <Reveal className="lg:col-span-7" data-id="element-16" data-mp="1d0s632bnh739">
            <p className="font-display text-lg italic text-gold" data-id="element-17" data-mp="1i16ewml2sl2c">{t(ui.careers.eyebrow)}</p>
            <h2 id="careers-title" className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.05] text-white sm:text-5xl" data-id="element-18" data-mp="141om7w4nsnnp">
              {t(ui.careers.title)}
            </h2>
            <p className="mt-5 text-xl text-white/90" data-id="element-19" data-mp="2zwmg1f542qch">{t(ui.careers.subtitle)}</p>

            <ul className="mt-8 space-y-3" data-id="element-20" data-mp="2uxtb4b3w47nx">
              {careerCommitments.map(c => <li key={c.en} className="flex gap-3 text-[15px] leading-relaxed text-white/85" data-id="element-21" data-mp="2v05mg5f57js0">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-22" data-mp="39spot3ugxn8e" />
                  {t(c)}
                </li>)}
            </ul>

            <ul className="mt-10 grid grid-cols-2 gap-px border border-white/10 bg-white/10 sm:grid-cols-3" data-id="element-23" data-mp="2h6wm0u96a8lm">
              {careerBenefits.map(b => {
              const Icon = b.icon;
              return <li key={b.label.en} className="flex items-center gap-3 bg-ink px-4 py-4" data-id="element-24" data-mp="2qyalx351dafa">
                    <Icon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-25" data-mp="2m3em3gtk5irm" />
                    <span className="text-xs font-bold uppercase tracking-wider text-white" data-id="element-26" data-mp="1ye2egldvpirf">{t(b.label)}</span>
                  </li>;
            })}
            </ul>

            <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-27" data-mp="2j46ch2e8p7vu">
              <a href="#apply" className="btn-gold h-14 px-8 text-base" data-id="element-28" data-mp="2n6193tl86x3a">
                {t(ui.common.joinTeam)}
              </a>
              <a href={business.phoneHref} className="btn-outline h-14 px-6" data-id="element-29" data-mp="2rykn2rntru8m">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-30" data-mp="2wwm7ph0wg1m7" />
                {t(ui.careers.callApply)}
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="lg:col-span-5" data-id="element-31" data-mp="247p0c8y87p88">
            <figure data-id="element-32" data-mp="24875jv2v9dsa">
              <img src={careersImage} alt={t(ui.careers.imageAlt)} loading="lazy" decoding="async" className="aspect-[4/5] w-full object-cover" data-id="element-33" data-mp="249rpyrvgvgcf" />
              <figcaption className="border-x border-b border-gold/30 bg-ink px-5 py-4" data-id="element-34" data-mp="3kmgk5xhb3o5x">
                <span className="block text-xs text-smoke" data-id="element-35" data-mp="3pkrsu4vv7smk">{t(ui.careers.flagsLabel)}</span>
                <ul className="mt-3 flex flex-wrap gap-x-4 gap-y-2" data-id="element-36" data-mp="1dxoidgdk445u">
                  {teamFlags.map(f => <li key={f.code} className="flex items-center gap-2 text-sm text-white" data-id="element-37" data-mp="18y1xqlvefln0">
                      <img src={`https://flagcdn.com/w40/${f.code}.png`} alt="" width={20} height={14} loading="lazy" className="h-3.5 w-5 rounded-[2px] object-cover" data-id="element-38" data-mp="147lgeqogjfvd" />
                      {t(f.name)}
                    </li>)}
                </ul>
              </figcaption>
            </figure>
          </Reveal>
        </div>

        <Reveal className="mt-20 border-t border-white/10 pt-14" data-id="element-39" data-mp="gapkx3f1is6w">
          <div id="apply" className="flex flex-col gap-10 lg:flex-row lg:items-start lg:gap-16" data-id="element-40" data-mp="gcacql9yzx12">
            <div className="lg:w-72 lg:shrink-0" data-id="element-41" data-mp="2fknwlkmna3f0">
              <h3 className="font-display text-2xl font-bold uppercase text-white" data-id="element-42" data-mp="2ap8o787eozpz">{t(ui.careers.stepsTitle)}</h3>
              <p className="mt-4 border-l-2 border-gold pl-4 font-display text-lg italic text-white/90" data-id="element-43" data-mp="2ip68vvv0b9qb">
                {t(ui.careers.belief)}
              </p>
            </div>
            <ol className="relative grid flex-1 gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-44" data-mp="28pfgbzq0b4sv">
              <span className="absolute left-5 right-5 top-5 hidden h-px bg-gold/40 lg:block" aria-hidden="true" data-id="element-45" data-mp="2doqztghrcoe5" />
              {applicationSteps.map((step, i) => <li key={step.en} className="relative flex items-center gap-4 lg:flex-col lg:items-start" data-id="element-46" data-mp="24ovh8qlvhr43" data-mpi={i}>
                  <span className="relative z-10 grid h-10 w-10 shrink-0 place-items-center rounded-full border-2 border-gold bg-charcoal font-display text-base font-bold text-gold" data-id="element-47" data-mp="1q07pywj283jy">
                    {i + 1}
                  </span>
                  <span className="text-lg font-semibold text-white" data-id="element-48" data-mp="1h0ccum5y1yha">{t(step)}</span>
                </li>)}
            </ol>
          </div>
          <a href={business.phoneHref} className="btn-gold mt-10 h-14 px-8 text-base" data-id="element-49" data-mp="12ckm2bagjgug">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-50" data-mp="12ef8xv5ahj16" />
            {t(ui.careers.callApply)}
          </a>
        </Reveal>
      </div>
    </section>;
}